"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialOfferShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const commercial_offer_1 = require("../../../model/commercial_offer");
const helpers_1 = require("../../../utils/helpers");
const tabs_1 = require("../../../widgets/tabs");
const commercial_offer_form_1 = require("./commercial_offer_form");
exports.CommercialOfferShow = {
    offer: {},
    fetched: false,
    currentTab: "infos",
    oncreate(vnode) {
        let id = vnode.attrs.id;
        this.fetch(id);
    },
    fetch(id) {
        this.fetched = false;
        commercial_offer_1.CommercialOfferProvider.show(id).then((offer) => {
            this.offer = offer;
            this.fetched = true;
            mithril_1.default.redraw();
        });
    },
    renderTabs() {
        if (this.fetched) {
            return (0, mithril_1.default)(tabs_1.Tabs, {
                selected: this.currentTab,
                ontabchange: (pane) => { this.currentTab = pane; },
                class: "is-centered"
            }, this.renderInfos());
        }
        return undefined;
    },
    renderInfos() {
        return (0, mithril_1.default)("div", { class: "content", key: "infos", dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-star"), (0, mithril_1.default)("span", "Infos")) }, (0, helpers_1.renderProperties)({
            "Nom": this.offer.name,
            "ID": this.offer.id,
            "Actif": (this.offer.active ? "OUI" : "NON"),
            "Créé le": (0, helpers_1.formatTime)(this.offer.created_at),
            "Temps total": (0, helpers_1.minutesToUnit)(this.offer.total_minutes),
            "Minutes d'annulation libre": (0, helpers_1.minutesToUnit)(this.offer.free_cancel_minutes),
            "Valeur (HT)": (0, helpers_1.moneyToString)(this.offer.value),
            "Valeur (TTC)": (0, helpers_1.moneyToString)((0, helpers_1.withVAT)(this.offer.value)),
        }));
    },
    view(_vnode) {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("div", { class: "content" }, (0, mithril_1.default)("h3", `Offre commerciale #${this.offer.id}`)), (0, mithril_1.default)("div", { class: "content columns" }, (0, mithril_1.default)("p", { class: "buttons" }, (0, mithril_1.default)("a", { class: "button is-primary",
            onclick: () => { commercial_offer_form_1.CommercialOfferForm.show(this.offer); }
        }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Editer")))), this.renderTabs());
    }
};
